import React from 'react';
import '../Gallery.css';
import ThingThumbnail from './ThingThumbnail';
import IndexTable from './IndexTable';
import { useGlobalContext } from '../../utils/GlobalContext';
import { Link } from 'react-router-dom';
import { projectUrl, ORDERED_PROJECTS } from '../../utils/projectsData';
import { playNextNote, resetMelody, HOVER_COLORS } from '../../utils/hoverMelody';

export default function Things() {
  const { numbersActive, imagesActive, tableActive, tokenSearchVal } = useGlobalContext();

  // every visit to the gallery starts the tune from the top
  React.useEffect(() => { resetMelody(); }, []);

  const ordered = ORDERED_PROJECTS;

  const search = (tokenSearchVal || '').trim().toLowerCase();
  const shown = search
    ? ordered.filter(({ p }) =>
        p.title.toLowerCase().includes(search) ||
        (p.for || '').toLowerCase().includes(search))
    : ordered;

  return (
    <div>
      <div className="home-container">
        <div className="body-text">
          {search
            ? <>There {shown.length === 1 ? 'is' : 'are'} {shown.length} {shown.length === 1 ? 'project' : 'projects'} matching <strong>{search}</strong>.</>
            : <>&nbsp;</>}
        </div>

        {imagesActive && (
          <div className="grid-container">
            {shown.map(({ p, id }) => (
              <div key={`project-${id}`} className="grid-item">
                <ThingThumbnail imageIndex={id} />
              </div>
            ))}
          </div>
        )}

        {tableActive && <IndexTable />}

        {numbersActive && (
          <div className={search ? 'numbers-container-filtered' : 'numbers-container'}>
            {shown.map(({ p, id }) => (
              <Link
                className="number-item"
                key={`project-${id}`}
                to={projectUrl(p)}
                style={{ '--hover-color': HOVER_COLORS[id % HOVER_COLORS.length] }}
                onMouseEnter={playNextNote}
              >
                {p.title}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
